import clsx from 'clsx';
import { DetailedHTMLProps, InputHTMLAttributes } from 'react';

export interface SwitchProps extends Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'id' | 'type'> {
  alternateColor?: boolean;
  id: string;
  checked: boolean;
  label?: string;
}

export const Switch: React.FC<SwitchProps> = ({ alternateColor = false, id, label, checked, onChange, ...rest }) => (
  <label htmlFor={id} className='group relative flex gap-x-2 text-sm font-normal text-gray-700'>
    <input
      {...rest}
      id={id}
      type='checkbox'
      checked={checked}
      onChange={onChange}
      className='peer absolute left-1/2 h-full w-full -translate-x-1/2 cursor-pointer appearance-none rounded-md'
    />
    <span
      className={clsx(
        'flex h-5 w-10 shrink-0 items-center rounded-[40px] p-1',
        'duration-300 ease-in-out after:h-4 after:w-4 after:rounded-full after:bg-white',
        'after:shadow-md after:duration-300',
        'cursor-pointer peer-checked:after:translate-x-4',
        'peer-disabled:opacity-50',
        alternateColor ? 'bg-[rgba(0,0,0,0.25)] peer-checked:bg-[#1890ff]' : 'peer-checked:bg-primary bg-gray-300',
      )}
    />
    <span className='hidden md:inline'>{label}</span>
  </label>
);

export default Switch;
